import { SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_HOUSEHOLD_AND_LISTING_ID } from 'api/actionTypes';

export default async function getBy({ state, apiClient }, { householdId, listingId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_LISTING_GET_BY_HOUSEHOLD_AND_LISTING_ID,
    state: state,
    payload: {
      householdId,
      listingId,
    },
    onSuccess(householdListing) {
      state.set(
        ['household', 'householdListingsBy', `${householdId}-${listingId}`],
        householdListing,
      );
      return householdListing;
    },
  });
}
